var map = {
	"./audits.svg": "ab04",
	"./calendar.svg": "0730",
	"./category.svg": "d73e",
	"./dashboard.svg": "81ba",
	"./files.svg": "4994",
	"./findings.svg": "2c8d",
	"./issues.svg": "ec88",
	"./issuesSolving.svg": "d16c",
	"./logout.svg": "67fa",
	"./measure.svg": "f0c1",
	"./panelDashboards.svg": "65ce",
	"./productInspection.svg": "1859",
	"./reportedChecklists.svg": "0d40",
	"./reportedIssueSolving.svg": "401c",
	"./reportedMaintenance.svg": "359b",
	"./reportedProductInspection.svg": "deb2",
	"./reports.svg": "e5b9",
	"./resources.svg": "091c",
	"./responses.svg": "9378",
	"./settings.svg": "aa47",
	"./shiftReport.svg": "e05e",
	"./shiftStations.svg": "9566",
	"./shiftWork.svg": "cb6d",
	"./shiftWorks.svg": "739d",
	"./shifts.svg": "ecf3",
	"./tasks.svg": "e9ac",
	"./unanswered-responses.svg": "a116",
	"./waitingMaintenance.svg": "13ce",
	"./workTasks.svg": "57b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef65";